<template>
  <DialogLayout
    title="補正登録"
    :visible.sync="dialogVisible"
    width="65em"
    @open="open"
  >
    <template #form>
      <FeesForPaidPassengersForm
        ref="feesForPaidPassengersForm"
        v-model="feesForPaidPassengersFormModel"
        label-width="10em"
        formMode="register"
        billingYmMode="this"
        :autocomplete-airport-code-set="autocompleteAirportCodeSet"
        :autocomplete-customer-code-set="autocompleteCustomerCodeSet"
      />
    </template>
    <template #footer>
      <RegisterDialogFooter
        @clear="clickClear"
        @register="clickRegister"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import FeesForPaidPassengersForm from '@/components/organisms/dialog/calculation/FeesForPaidPassengersForm.vue'
import RegisterDialogFooter from '@/components/organisms/dialog/RegisterDialogFooter.vue'
import AirportAutocompleteLoader from '@/mixins/AirportAutocompleteLoader.vue'
import CustomerAutocompleteLoader from '@/mixins/CustomerAutocompleteLoader.vue'

export default {
  components: {
    DialogLayout,
    FeesForPaidPassengersForm,
    RegisterDialogFooter
  },
  mixins: [
    AirportAutocompleteLoader,
    CustomerAutocompleteLoader
  ],
  props: {
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteAirportCodeSet: {
      type: Array,
      default: () => ([])
    },
    currentRow: {
      type: Object,
      default: () => {
        return {}
      }
    },
    visible: Boolean
  },
  data () {
    return {
      feesForPaidPassengersFormModel: {
        billing_ym: this.getDefaultBillingYm(),
        bill_to_code: undefined,
        departure_airport_code: undefined,
        seats: undefined,
        paid_passengers: undefined,
        aircraft_weight_type: undefined,
        passenger_landing_fee_without_tax: undefined,
        passenger_landing_fee_tax: undefined,
        passenger_landing_fee_with_tax: undefined,
        passenger_landing_fee_before_exemption: undefined,
        tax: undefined,
        taxation: undefined,
        exemption_code: undefined,
        exemption_rate: undefined,
        unit_fee: undefined,
        landingFeeBeforeExemption: undefined
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (visible) {
        this.$emit('update:visible', visible)
      }
    }
  },
  mounted () {
  },
  methods: {
    clickClear () {
      this.$refs.feesForPaidPassengersForm.clearFields()
    },
    async clickRegister () {
      this.$loadingMask.on()
      this.$refs.feesForPaidPassengersForm.validate()
        .then((valid) => {
          return this.$axios.post('/fees-for-paid-passengers', this.feesForPaidPassengersFormModel)
        })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.dialogVisible = false
          this.$emit('refresh', this.feesForPaidPassengersFormModel.billing_ym)
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message)
                break
              default:
            }
          }
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    open () {
      const trimItem = ['bill_to_code', 'departure_airport_code']
      this.$nextTick(() => {
        this.$refs.feesForPaidPassengersForm.clearFields()
        Object.keys(this.feesForPaidPassengersFormModel)
          .forEach((x) => {
            if (trimItem.includes(x) && this.currentRow[x]) {
              this.currentRow[x] = this.currentRow[x].trimEnd()
            }
            if (this.currentRow[x] !== undefined) {
              this.$set(this.feesForPaidPassengersFormModel, x, this.currentRow[x])
            }
          })
      })
    }
  }
}
</script>

<style lang="scss">
</style>
